import _ from "lodash";
import { ACCOUNT_CHANGED } from "../actionTypes";
import { PPA_CONTRACT_CLICKED, PPA_CONTRACT_RESET, PPA_CONTRACT_VALUE_CHANGE, RETRIEVE_PPA_CONTRACTS_SUCCESS } from "./PpaContractActionTypes"
import moment from "moment/moment";

const initialState = {
    ppaContracts: [],
    ppaContract: {
        offtakerName: '',
        settlementType: '',
        deliveryPointPnode: '',
        deliveryPointPnodeId: '',
        dayAheadOrRealTime: ''
    }
}

const ppaContractReducer = (state = initialState, action) => {
    switch (action.type) {
        case RETRIEVE_PPA_CONTRACTS_SUCCESS:
            return ({ ...state, ppaContracts: action.ppaContracts });
        case PPA_CONTRACT_VALUE_CHANGE:
            return ({ ...state, ppaContract: { ...action.ppaContract } });
        case PPA_CONTRACT_CLICKED:
            let ppa = _.clone(action.ppaContract);
            ppa.startDate = moment(ppa.startDate);
            ppa.endDate = moment(ppa.endDate);
            return ({ ...state, ppaContract: ppa });
        case PPA_CONTRACT_RESET:
            return ({ ...state, ppaContract: initialState.ppaContract });
        case ACCOUNT_CHANGED:
            return initialState;
        default:
            return state;
    }
}

export default ppaContractReducer;